// import { formatString } from "./helper";

// const ProductCard = ({ product, onClick }) => {
//     const imageUrl = product.image || `https://placehold.co/100x100/3B82F6/ffffff?text=${formatString(product.name)}`;

//     return (
//         <div
//             onClick={onClick}
//             className="cursor-pointer bg-white border rounded-xl p-4 flex flex-col items-center shadow hover:shadow-md transition"
//         >
//             <img
//                 src={imageUrl}
//                 alt={formatString(product.name)}
//                 className="w-20 h-20 object-cover rounded mb-2"
//                 onError={(e) => { e.target.src = `https://placehold.co/100x100/3B82F6/ffffff?text=No+Image`; }}
//             />
//             <h3 className="text-center text-sm font-semibold">{formatString(product.name)}</h3>
//             <p className="text-blue-600 font-bold mt-1">₹{product.price}</p>
//         </div>
//     );
// };

// export default ProductCard;


import { formatString } from "./helper";

const getInitials = (name) => {
    return name
        ?.split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
};

const ProductCard = ({ product, onClick }) => {
    const hasImage = Boolean(product.image);

    return (
        <div
            onClick={onClick}
            className="cursor-pointer bg-white border rounded-lg overflow-hidden shadow hover:shadow-md transition-all duration-200 w-full max-w-[200px]"
        >
            <div className="h-40 w-full bg-gray-100">
                {hasImage ? (
                    <img
                        src={product.image}
                        alt={formatString(product.name)}
                        className="w-full h-full object-fill"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "";
                        }}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center bg-blue-100 text-blue-600 text-3xl font-bold">
                        {getInitials(product.name)}
                    </div>
                )}
            </div>

            <div className="p-3 text-center space-y-1">
                <h3 className="text-sm font-semibold text-gray-800 leading-snug line-clamp-2">
                    {formatString(product.name)}
                </h3>
                <p className="text-blue-600 font-bold text-sm">₹{product.price}</p>
            </div>
        </div>
    );
};

export default ProductCard;

